import React from 'react';
import { compose, defaultProps, mapProps } from 'recompose';

export const Icon = compose<Props, any>(
  defaultProps({
    width: 16,
    height: 16
  }),
  mapProps(({ name, ...rest }) => {
    const res = require(`icons/${name}.svg`);
    return {
      ...rest,
      content: { __html: `<use xlink:href="${res.url}"></use>` }
    }
  })
)(({ content, ...rest }: any) =>
  <svg {...rest} dangerouslySetInnerHTML={content} />
);

interface Props extends SVGElement{
  name: string
}

export default Icon;
